import React from 'react';
import { BresBetMainLogoWrapper, BresBetMainLogo } from './bresbet.style';

export const BresbetLogotype = (): JSX.Element => (
    <BresBetMainLogoWrapper>
        <BresBetMainLogo />
    </BresBetMainLogoWrapper>
);
